import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import {Button, Form, Spinner} from "react-bootstrap";

const UpdateEmailInquiries = () => {
    let navigate = useNavigate();

    const [name, set_name] = useState('N/A')
    const [message, set_message] = useState('N/A')
    const [email, set_email] = useState('N/A')
    const [done, set_done] = useState('N/A')

    const [doneSubmitting, setDoneSubmitting] = useState(false)

    const {id} = useParams();

    const userLogin = useSelector(state => state.userLogin);
    const {userInfo} = userLogin;

    const loadEmails = async () => {
        const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/home_page_contact/${id}/`, {
        // const {data} = await axios.get(`http://127.0.0.1:8000/api/home_page_contact/${id}/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        });
        set_name(data.name)
        set_message(data.message)
        set_email(data.email)
        set_done(data.done)
        // console.log(data)
    }


    useEffect(() => {
        loadEmails();
    }, [])

    const UpdateEmail = async () => {
        setDoneSubmitting(true)
        let formField = new FormData()

        formField.append('name', name)
        formField.append('message', message)
        formField.append('email', email)
        formField.append('done', done)
        await axios({
            method: 'PUT',
            url: `https://homesafetysolutions.pythonanywhere.com/api/home_page_contact/update/${id}/`,
            // url: `http://127.0.0.1:8000/api/home_page_contact/update/${id}/`,
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            },
            data: formField,
        }).then(() => {
            navigate('/email_report')
        })
        setDoneSubmitting(false)
    }


    return (
        <div className={"banner_heading"}>

            <h1>Update Comment:</h1>

            <Form>

                <Form.Group controlId={'name'}>
                    <Form.Label>Name:</Form.Label>
                    <Form.Control
                        type={'text'}
                        placeholder={"Name"}
                        value={name}
                        onChange={(e) => set_name(e.target.value)}
                    />
                </Form.Group>

                <Form.Group controlId={'message'}>
                    <Form.Label>Message:</Form.Label>
                    <Form.Control
                        type={'text'}
                        placeholder={"Message"}
                        value={message}
                        onChange={(e) => set_message(e.target.value)}
                    />
                </Form.Group>

                <Form.Group controlId={'email'}>
                    <Form.Label>Email:</Form.Label>
                    <Form.Control
                        type={'email'}
                        placeholder={"Email"}
                        value={email}
                        onChange={(e) => set_email(e.target.value)}
                    />
                </Form.Group>

                <Form.Group controlId={'done'}>
                    <Form.Label>Answered?:</Form.Label>
                    <Form.Select
                        value={done}
                        onChange={(e) => set_done(e.target.value)}
                    >
                        <option value={"DEFAULT"} disabled>Have we answered to their email?</option>
                        <option value="No">No</option>
                        <option value="Yes">Yes</option>
                    </Form.Select>
                </Form.Group>

                <br/>
                {
                    doneSubmitting
                        ?
                        (
                            <span>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Loading...
                            </span>
                        )
                        :
                        (
                            <Button className={'btn btn-success'} onClick={UpdateEmail}>Update Email</Button>
                        )
                }
            </Form>


        </div>
    );
};

export default UpdateEmailInquiries;
